module.exports = __webpack_public_path__ + "static/media/replaceProducts.e33a04ef.svg";